import { render, staticRenderFns } from "./DataBlockGoal.vue?vue&type=template&id=2387d694&scoped=true"
import script from "./DataBlockGoal.vue?vue&type=script&lang=ts"
export * from "./DataBlockGoal.vue?vue&type=script&lang=ts"
import style0 from "./DataBlockGoal.vue?vue&type=style&index=0&id=2387d694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387d694",
  null
  
)

export default component.exports